import { createSlice } from '@reduxjs/toolkit'
import CommonServices from '../../services/commonServices';
import TemplateServices from '../../services/templateServices';
import { adminGroup, roles } from '../../utils/permissionUtils';
import { logTypesCode } from '../../utils/constants';

const initialState = {
  templates: [],
  salesOrganization: [],
  userCountries: [],
  countries: [],
  standardOrderFields: [],
  quotatios: [],
  orderStatuses: [],
  rpaTemplateTypes: [],
  logTypes: [],
  templateTypes: []
};

const untilsSlice = createSlice({
  name: 'utils',
  initialState,
  reducers: {
    templatesLoaded(state, action) {
      state.templates = action.payload;
    },
    salesOrganizationLoaded(state, action) {
      state.salesOrganization = action.payload;
    },
    countriesLoaded(state, action) {
      state.countries = action.payload;
    },
    userCountriesLoaded(state, action) {
      state.userCountries = action.payload;
    },
    standardFieldsLoaded(state, action) {
      state.standardOrderFields = action.payload;
    },
    quoationsLoaded(state, action) {
      state.quotatios = action.payload;
    },
    orderStatusesLoaded(state, action) {
      state.orderStatuses = action.payload;
    },  
    rpaTemplateTypesLoaded(state, action) {
      state.rpaTemplateTypes = action.payload;
    },
    logTypesLoaded(state, action) {
      state.logTypes = action.payload;
    },
    templateTypesLoaded(state, action) {
      state.templateTypes = action.payload;
    }
  },
})

export const { templatesLoaded, salesOrganizationLoaded, countriesLoaded, userCountriesLoaded, standardFieldsLoaded, quoationsLoaded, orderStatusesLoaded, rpaTemplateTypesLoaded, logTypesLoaded, templateTypesLoaded } = untilsSlice.actions;

export default untilsSlice.reducer;

export const fetchTemplates = (currentUser) => async (dispatch) => {
  const userCountryID = currentUser.lastSelectedCountryID ?? null;
  try {
    const respData = await TemplateServices.getTemplates(userCountryID);
    if (respData.success) {
      const templates = respData.responseObject.value.templates;
      dispatch(templatesLoaded(templates));
    }
  } catch (error) {
    console.error('Failed to fetch:', error.message);
  }
};

export const fetchSalesOrganization = () => async (dispatch) => {
  try {
    const respData = await CommonServices.getSalesOrganization();
    if (respData.success) {
      const salesOrganization = respData.responseObject.value.salesOrganizations;
      dispatch(salesOrganizationLoaded(salesOrganization));
    }
  } catch (error) {
    console.error('Failed to fetch:', error.message);
  }
};

export const fetchUserCountries = (userID) => async (dispatch) => {
  try {
    const respData = await CommonServices.getUserCountries(userID);
    if (respData.success) {
      const countries = respData.responseObject.value.countries;
      dispatch(userCountriesLoaded(countries));
    }
  } catch (error) {
    console.error('Failed to fetch:', error.message);
  }
};

export const fetchCountries = () => async (dispatch) => {
  try {
    const respData = await CommonServices.getCountries();
    if (respData.success) {
      const countries = respData.responseObject.value.countries;
      dispatch(countriesLoaded(countries));
    }
  } catch (error) {
    console.error('Failed to fetch:', error.message);
  }
};

export const fetchStandardOrderTemplateFields = () => async (dispatch) => {
  try {
    const respData = await TemplateServices.getStandardOrderTemplateFields();
    if (respData.success) {
      const standardFields = respData.responseObject.value.standardTemplateDbFields;
      dispatch(standardFieldsLoaded(standardFields));
    }
  } catch (error) {
    console.error('Failed to fetch:', error.message);
  }
};

export const fetchQuotations = () => async (dispatch) => {
  try {
    const respData = await CommonServices.getQuotatios();
    if (respData.success) {
      const quotatios = respData.responseObject.value.quotations;
      dispatch(quoationsLoaded(quotatios));
    }
  } catch (error) {
    console.error('Failed to fetch:', error.message);
  }
};  

export const fetchOrderStatuses = () => async (dispatch) => {
  try {
    const respData = await CommonServices.getOrderStatuses();
    if (respData.success) {
      const orderStatuses = respData.responseObject.value.orderStatuses;
      dispatch(orderStatusesLoaded(orderStatuses));
    }
  } catch (error) {
    console.error('Failed to fetch:', error.message);
  }
};

export const fetchRpaTemplateTypes = () => async (dispatch) => {
  try {
    const respData = await CommonServices.getRpaTemplateTypes();
    if (respData.success) {
      const rpaTemplateTypes = respData.responseObject.value.rpaTemplateTypes;
      dispatch(rpaTemplateTypesLoaded(rpaTemplateTypes));
    }
  } catch (error) {
    console.error('Failed to fetch:', error.message);
  }
};

export const fetchLogTypes = (roleCode) => async (dispatch) => {
  try {
    const respData = await CommonServices.getLogTypes();
    if (respData.success) {
      let logTypes = [];
      if (roleCode !== roles.d2c) {
        logTypes = respData.responseObject.value.logTypes;
      } else {
        logTypes = respData.responseObject.value.logTypes.filter(logType => logType.code === logTypesCode.orderD2C);
      }
      dispatch(logTypesLoaded(logTypes));
    }
  } catch (error) {
    console.error('Failed to fetch:', error.message);
  }
};

export const fetchTemplateTypes = () => async (dispatch) => {
  try {
    const respData = await CommonServices.getTemplateTypes();
    if (respData.success) {
      const templateTypes = respData.responseObject.value.templateTypes;
      dispatch(templateTypesLoaded(templateTypes));
    }
  } catch (error) {
    console.error('Failed to fetch:', error.message);
  }
};